/* eslint-disable */
import React from 'react'
import { Form, Modal, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import Spinner from '../../../../partials/content/Spinner'

function GenericModalBodyLoading(props) {
  const { loadingPhraseId } = props

  // Render component
  return (
    <>
      <Form>
        <Modal.Body>
          <Row>
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="centered">
                <Spinner />
                <p className="font-lg font-bolder font-color-2">
                  <FormattedMessage id={loadingPhraseId ? loadingPhraseId : 'GENERAL.LOADING' + '...'} />
                </p>
              </div>
            </div>
          </Row>
        </Modal.Body>
      </Form>
    </>
  )
}

export default GenericModalBodyLoading
